import { Spin } from 'antd';

/** 页面/路由加载占位 */
export default function PageLoading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 240,
        width: '100%',
      }}
    >
      <Spin size="large" />
    </div>
  );
}
